import React, { useMemo } from 'react';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useTranslation } from 'react-i18next';

import TooltipButton from '../tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../common-button/CommonButton';
import Icon from '../../icons/Icon';
import CircleCounter from '../circle-counter/CircleCounter';

import scss from './CommonFilterButton.module.scss';

function CommonFilterButton({ onOpen, selectedFilters, isShowCounter }) {
  const { t } = useTranslation();

  const selectedFiltersNum = useMemo(() => Object.values(selectedFilters).flat().length, [selectedFilters]);

  const handleOpenModal = () => {
    onOpen(true);
  };

  return (
    <TooltipButton
      styleColor={BUTTON_STYLES.SECONDARY}
      maxWidth={40}
      tooltip={t('filters')}
      className={scss.filterButton}
      onClick={handleOpenModal}>
      <Icon icon={FilterAltOutlinedIcon} />
      {isShowCounter ? (
        <div className={scss.counterWrapper}>
          <CircleCounter count={selectedFiltersNum} />
        </div>
      ) : null}
    </TooltipButton>
  );
}

export default CommonFilterButton;
